var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"not-found-page py-5"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('h1',{staticClass:"text-white"},[_vm._v("404 - "+_vm._s(_vm.$t('not_found_message')))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }